module.exports = __webpack_public_path__ + "img/望都辣椒加工.ae3c026f.jpg";